import * as Sentry from "@sentry/react";
import { sanitizeSentryEvent } from "@shared/sentry-privacy";

export function filterExceptionDroppingIntegrations<
  T extends { name: string },
>(integrations: T[]): T[] {
  // The SDK's default filters can silently discard real exceptions. In this
  // installed version the default is named InboundFilters; EventFilters is the
  // replacement name, so exclude both across SDK upgrades.
  return integrations.filter(
    ({ name }) => !["InboundFilters", "EventFilters", "Dedupe"].includes(name),
  );
}

// Import this before application modules so startup errors (including Firebase
// initialization) have a client rather than being lost before main.tsx runs.
if (import.meta.env.VITE_SENTRY_DSN) {
  try {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
      release: import.meta.env.VITE_SENTRY_RELEASE,
      sendDefaultPii: false,
      beforeSend: sanitizeSentryEvent,
      beforeBreadcrumb: () => null,
      integrations: filterExceptionDroppingIntegrations,
    });
  } catch {
    // A monitoring initialization failure must not prevent application startup.
  }
}